<template>
  <div class="p-12 bg-gray-200 min-h-screen">Verifying ...</div>
</template>

<script>
export default {
  props: {
    id: {
      type: String,
      required: true,
    },
    hash: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      expires: this.$route.query?.expires || '',
      signature: this.$route.query?.signature || '',
    };
  },
  created() {
    this.verify();
  },
  methods: {
    async verify() {
      try {
        await this.$store.dispatch('ui/auth/verifyEmail', {
          id: this.id,
          hash: this.hash,
          expires: this.expires,
          signature: this.signature,
        });

        this.$router.replace({ name: 'home' });
      } catch (error) {
        //
      }
    },
  },
};
</script>
